import { render, staticRenderFns } from "./RandomChatMatch.vue?vue&type=template&id=951dffce&"
import script from "./RandomChatMatch.vue?vue&type=script&lang=js&"
export * from "./RandomChatMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports